import { Box, BoxProps, CircularProgress } from '@/primitives';

export function LoadingPage(props: BoxProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="65vh"
      width="100%"
      {...props}
    >
      <CircularProgress />
    </Box>
  );
}
